"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textureSources = void 0;
exports.textureSources = [
    {
        name: 'gradientCubeTexture',
        type: 'cubeTexture',
        paths: [
            './assets/images/cubemap/gs-gradient/px.png',
            './assets/images/cubemap/gs-gradient/nx.png',
            './assets/images/cubemap/gs-gradient/py.png',
            './assets/images/cubemap/gs-gradient/ny.png',
            './assets/images/cubemap/gs-gradient/pz.png',
            './assets/images/cubemap/gs-gradient/nz.png'
        ]
    },
    {
        name: 'cubeMatcap',
        type: 'texture',
        path: './assets/images/matcap/BlackRough.png'
    }
];
